import '../Styles/Header.css';
import { Link } from "react-router-dom";
import Menu from "../Img/menu.svg"
import Close from '../Img/close.svg'
import es from '../Img/argentina.png'

function Header(props) {

  function navButton() {
    if (document.getElementById("Header__navLinks")) {
      document.getElementById("Header__navLinks").style.display = 'grid'
    }
  }

  function closeButton() {
    if (
      document.getElementById("Header__navLinks")
    ) {
      if (window.innerWidth < 770) {
          document.getElementById("Header__navLinks").style.display = 'none'
      }
    }
  }

  function changeLanguage() {
    if (props.language === props.uk) {
      props.setLanguage(es)
    } else {
      props.setLanguage(props.uk)
    }
  }

  return (
    <div className="Header__container">

      <div className="Header__title">
        <h1 data-aos="fade-zoom-in" data-aos-duration="1500">Matias Aguilar</h1>
        <p data-aos="fade-zoom-in" data-aos-duration="1500">{props.language === props.uk ? "Freelance Developer" : "Desarrollador Freelance"}</p>
      </div>

      <div className="Header__flag" data-aos="fade-zoom-in" data-aos-duration="1500">
        <img src={props.language} alt="" onClick={changeLanguage} />
      </div>

      <div className="Header__nav" >

        <div className="Header__navIcon" onClick={navButton}>
          <img src={Menu} alt=""data-aos="fade-zoom-in" data-aos-duration="1500"/>
        </div>

        <div className="Header__navLinks" id='Header__navLinks'>
          <div className="Header__navLinksIcon" onClick={closeButton}>
              <img src={Close} alt="" />
          </div>
          <div className="Header__navLinksLinks" onClick={closeButton}>
            <Link id='About' className="Header__navLinksLink" to="/" data-aos="fade-zoom-in" data-aos-duration="1500" data-aos-delay="100">{props.language === props.uk ? "Home" : "Inicio"}</Link>
            <Link id='Projects' className="Header__navLinksLink" to="/projects" data-aos="fade-zoom-in" data-aos-duration="1500" data-aos-delay="200">{props.language === props.uk ? "Projects" : "Proyectos"}</Link>
            <Link id='Studies' className="Header__navLinksLink" to="/studies" data-aos="fade-zoom-in" data-aos-duration="1500" data-aos-delay="300">{props.language === props.uk ? "Studies" : "Estudios"}</Link>
            <Link id='Contact' className="Header__navLinksLink" to="/contact" data-aos="fade-zoom-in" data-aos-duration="1500" data-aos-delay="400">{props.language === props.uk ? "Contact" : "Contacto"}</Link>
          </div>
        </div>

      </div>

    </div>
  );
}

export default Header;